import { hashHistory } from 'react-router';
import * as React from 'react';
import autobind from 'autobind-decorator';

import { submitPasswordReset } from './resetPasswordUtils';
import * as accountRequestAPI from 'login-apis/accountRequestAPI';
import * as routerState from 'login-utils/routerState';
import ChoosePasswordForm, { CORE_PASSWORD_PROPERTY } from 'login-components/ChoosePasswordForm/ChoosePasswordForm';
import States from 'login-constants/states';
import ValidateRequestState from 'login-components/ValidateRequestState/ValidateRequestState';

@autobind
export default class ChooseResetPassword extends React.Component<{}, any> {
  async submitPasswordChangeRequest(formValues) {
    const valuesToSubmit = {
      password: formValues[CORE_PASSWORD_PROPERTY],
    };

    const { data } = await submitPasswordReset(valuesToSubmit);
    routerState.set('success', data as string);
    hashHistory.push(States.LOGIN);
  }

  validatePasswordReset() {
    return accountRequestAPI.validate('passwordReset');
  }

  render() {
    return (
      <div className="it-ChooseResetPassword">
        <ValidateRequestState validate={this.validatePasswordReset}>
          <ChoosePasswordForm submitPassword={this.submitPasswordChangeRequest} />
        </ValidateRequestState>
      </div>
    );
  }
}
